import(/* webpackMode: "eager" */ "/app/src/app/[lng]/(use-auth)/sobre-nosotros/page.tsx");
